var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star"},[_c('div',{staticClass:"empty-stars"}),_c('div',{staticClass:"full-stars",style:({ width: (_vm.star * 100) / 5 + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }